import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../../common/ui/Button'

const SubmitButton = ({
  handler,
  disabled,
  label,
  iconClasses,
  className = '',
  ...rest
}) => {
  return (
    <Button
      clickHandler  = {handler}
      className     = {`btn btn-secondary orange submit ${className}`}
      type          = "submit"
      disabled      = {disabled}
      {...rest}
      >
      <i className={`left ${iconClasses}`} />
      <span>{label}</span>
      <i className={`fas fa-angle-double-right ${!disabled ? "animated heartBeat infinite slower" : ''}`} />
    </Button>
  )
}

SubmitButton.propTypes = {
  handler: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  iconClasses: PropTypes.string,
  className: PropTypes.string
}

export default SubmitButton